import { ComponentProps } from 'react';
import { twMerge } from 'tailwind-merge';

export type RootProps = ComponentProps<'div'>;

export function Root({ className, ...props }: RootProps) {
  return <div className={twMerge('relative', className)} {...props} />;
}
